export interface DomainInfo {
  hostname: string;
  domain: string;
  subdomain: string | null;
  protocol: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
  fullUrl: string;
  userAgent: string;
  referrer: string;
  timestamp: Date;
}

export const getDomainInfo = (): DomainInfo => {
  const location = window.location;
  const hostname = location.hostname;
  
  // 도메인과 서브도메인 분리
  const domainParts = hostname.split('.');
  const domain = domainParts.length >= 2 
    ? domainParts.slice(-2).join('.') 
    : hostname;
  const subdomain = domainParts.length > 2 
    ? domainParts.slice(0, -2).join('.') 
    : null;

  return {
    hostname,
    domain,
    subdomain,
    protocol: location.protocol,
    port: location.port,
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
    fullUrl: location.href,
    userAgent: navigator.userAgent,
    referrer: document.referrer,
    timestamp: new Date()
  };
};

export const logDomainAccess = (domainInfo: DomainInfo) => {
  console.log('🔍 Domain Access Information:', domainInfo);
  
  // 개발 환경에서는 상세 로그
  if (process.env.NODE_ENV === 'development') {
    console.group('📊 Detailed Domain Analysis');
    console.log('Hostname:', domainInfo.hostname);
    console.log('Domain:', domainInfo.domain);
    console.log('Subdomain:', domainInfo.subdomain);
    console.log('Protocol:', domainInfo.protocol);
    console.log('Full URL:', domainInfo.fullUrl);
    console.log('User Agent:', domainInfo.userAgent);
    console.log('Referrer:', domainInfo.referrer);
    console.log('Timestamp:', domainInfo.timestamp.toISOString());
    console.groupEnd();
  }
  
  // 프로덕션에서는 간단한 로그만
  if (process.env.NODE_ENV === 'production') {
    console.log(`🌐 Access from: ${domainInfo.hostname} at ${domainInfo.timestamp.toISOString()}`);
  }
};

export const isLocalhost = (hostname: string): boolean => {
  return hostname === 'localhost' || 
         hostname === '127.0.0.1' || 
         hostname.startsWith('192.168.') ||
         hostname.startsWith('10.') ||
         hostname.startsWith('172.');
};

export const isProductionDomain = (hostname: string): boolean => {
  // 프로덕션 도메인 패턴 (예시)
  const productionPatterns = [
    /\.pittasoft\.com$/,
    /\.fleeta\.io$/,
    /\.amazonaws\.com$/,
    /\.cloudfront\.net$/
  ];
  
  return productionPatterns.some(pattern => pattern.test(hostname));
};

export const getEnvironmentFromDomain = (hostname: string): string => {
  if (isLocalhost(hostname)) {
    return 'development';
  }
  
  if (hostname.includes('dev') || hostname.includes('staging')) {
    return 'staging';
  }
  
  if (isProductionDomain(hostname)) {
    return 'production';
  }
  
  return 'unknown';
}; 